import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, unref as _unref, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/jobsearch/icon-display.svg'
import _imports_1 from '@/assets/img/pending/icon-no-result.svg'


const _hoisted_1 = { class: "l-wrapper" }
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "p-pending" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "p-pending_tit" }, "気になるリスト", -1)
const _hoisted_6 = { class: "p-jobsearch-header" }
const _hoisted_7 = { class: "p-jobsearch-header_inner" }
const _hoisted_8 = { class: "p-jobsearch-control" }
const _hoisted_9 = { class: "p-jobsearch-control_inner" }
const _hoisted_10 = { class: "p-jobsearch-control_count" }
const _hoisted_11 = { class: "p-jobsearch-control_count_highlight" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-control_buttons" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "p-jobsearch-control_buttons_display js-modal-open-button",
    type: "button",
    "data-modal-target": "modalDisplay"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "p-jobsearch-control_buttons_display_icon",
      src: _imports_0,
      alt: ""
    }),
    /*#__PURE__*/_createTextVNode("表示設定")
  ])
], -1)
const _hoisted_13 = { class: "p-jobsearch-control_inner __vertical" }
const _hoisted_14 = { class: "p-jobsearch-control_switch" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "switch" }, "まとめて選択", -1)
const _hoisted_16 = { class: "p-jobsearch-control_check" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "表示されている紹介求人を選択", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-control_term" }, "※一括操作は20件まで可能です。21件以上表示された状態で一括選択を行うと上部から20件が選択されます。", -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"p-jobsearch-list\"><div class=\"p-jobsearch-list_no-result\"><div class=\"p-jobsearch-list_no-result_heading\"><img class=\"p-jobsearch-list_no-result_img\" src=\"" + _imports_1 + "\" alt=\"\"><p>「気になる」求人はありません</p></div><div class=\"p-jobsearch-list_no-result_contents\"><p>少しでも興味のある求人は<br>「気になる」でまとめて、<br>後からゆっくり確認することもできます。</p></div></div></div>", 1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "p-jobsearch-list" }
const _hoisted_25 = { class: "p-jobsearch-list_more" }
const _hoisted_26 = ["disabled"]

import JobListItem from '@/components/JobListItem.vue';
import PendingFooter from '@/components/PendingFooter.vue';

// 「表示設定」モーダル
import { computed, nextTick, onActivated, ref } from 'vue';
import JobSearchFilterModals from '@/components/JobSearchFilterModals.vue';
import Loading from '@/components/Loading.vue';
import { useStore } from 'vuex';
import { TrnShintyokuPageCursor, TrnLikeMypageAddRequest, TrnShintyokuSelectRequest } from '@/types/request';
import { getPendingListService,  writeLogtrnOperationLogService } from '@/api/services/shintyokuService';
import { Job } from '@/types';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import { datefnsFormat, separatorDate } from '@/utils/dateFormat';
import { isArray } from 'lodash';
import { getMessageForInvalidOrders } from '@/utils/messageFormat';
import { postLikeMypageAdd } from '@/api/trnLikeMypageEndpoint';
import { setLikeMypageBulkRemoveService } from '@/api/services/trnLikeMypageService';
import { useRoute, useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'PendingView',
  setup(__props) {

const isDisplayModalOpen = ref(false); // 「表示設定」モーダルの表示状態を管理
const appliedFilters = ref<any>(null);
const appliedDisplayPeriod = ref('');
const appliedStartDate = ref<Date | null>(null);
const appliedEndDate = ref<Date | null>(null);
const shintyokuSelectParams = ref<TrnShintyokuSelectRequest>({});
const minDate = ref<Date | null>(null);
const maxDate = ref<Date | null>(null);
const pageCursor = ref<TrnShintyokuPageCursor | null>(null);
const isInitFilter = ref(false);

// 「まとめて選択」トグルの状態を管理するref
const isBulkSelectionEnabled = ref(false); // 初期値はOFF
const store = useStore();
const isLoading = ref(false);
const isLoadingMore = ref(false);
const currentPage = ref(1);
const totalCount = ref(0);
const hasMore = ref(false);
const isLoadingMulti = ref<boolean>(false);
const isJobListLoaded = ref(false);
const savedScrollTop = ref(0);

// 求人リストのダミーデータ
const jobList = ref<Job[]>([]);

const isAnyCheckboxChecked = computed(() => {
  return jobList.value.some(job => job.checked === true);
});

// 選択された求人件数をカウントする算出プロパティ
const selectedJobCount = computed(() => {
  return jobList.value.filter(job => job.checked).length;
});

// JobListItemからのcheckedイベントを処理
const updateJobChecked = async (progressId: number | undefined, orderId: number, checked: boolean) => {
  const job = jobList.value.find(j => Number(j.orderId) === orderId);
  if (job) {
    // 20件の上限を超えてチェックしようとした場合
    if (checked && selectedJobCount.value >= 20) {
      await store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.ORDER_BULK_LIMIT.SELECT_CHECK});
    } else {
      // それ以外の場合はチェックボックスの状態を更新
      job.checked = checked;
    }
  }
};

// JobListItemからのfavoriteイベントを処理
const updateJobFavorite = async (jobFavourite: Job, favorite: boolean) => {
  isAction.value = false;
  const orderId = Number(jobFavourite.orderId);
  const idx = jobList.value.findIndex(j => Number(j.orderId) === orderId);
  if (!favorite && idx >= 0) {
    const job = jobList.value[idx];
    job.isFavorite = favorite;
    const requestParams: TrnLikeMypageAddRequest = {
      orderId: orderId,
      addLikeFlag: 0
    };
    let res = await postLikeMypageAdd(requestParams);

    if (res.data.responseFault && res.data.responseFault.responseId !== 'N011') {
      const orders = [{ orderId: Number(orderId), realClientName: jobFavourite.companyName, positionName: jobFavourite.jobTitle }];
      if(res.data.detail && res.data.detail.ignoreOrderId != null){
        store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.IGNORED_ORDER_ERR_MESG_SINGLE + getMessageForInvalidOrders(orders)});
      }else{
        store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.NO_ACCESS_RIGHTS + getMessageForInvalidOrders(orders)});
      }
      job.isFavorite = !favorite;
      isAction.value = true;
      return;
    }

    removeFavoriteJob(orderId);
    await store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.UN_FAVORITE_DONE});    
  }
  isAction.value = true;
};

const removeFavoriteJob = (orderId: number) => {
    const jobDeleted = jobList.value.filter(job => Number(job.orderId) == orderId);
    if(jobDeleted.length)
    {
        jobList.value = jobList.value.filter(job => Number(job.orderId) != orderId);
        totalCount.value --;            
    }    
};

const writeLog = async(orderId: number, clientId: number, videoUrl: string) =>
{
  await writeLogtrnOperationLogService({
    orderId: orderId,
    clientId: clientId,
    operationId: 1,
    videoUrl: videoUrl,
  });
};

// 「表示されている紹介求人を選択」チェックボックスの処理
const handleCheckAllJob = (event: Event) => {
  const checked = (event.target as HTMLInputElement).checked;
  // チェックがONになった場合
  if (checked) {
    // 20件をチェック
    jobList.value.filter(job => job.isApply == false || job.isRefusal ).slice(0, 20).forEach(job => {
      job.checked = true;
    });
    jobList.value.filter(job => job.isApply == false || job.isRefusal).slice(20).forEach(job => {
      job.checked = false;
    });
  } else {
    // チェックがOFFになった場合、全てのチェックを外す
    jobList.value.forEach(job => {
      job.checked = false;
    });
  }
};

// 「表示設定」モーダルを閉じたタイミング処理(フィルタ適用内容を取得)
const handleApplyFilters = async (filters: { checkboxes: any, displayPeriod: string, startDate: Date | null, endDate: Date | null, isChanged: boolean | null}) => {
  if (!filters.isChanged) return;

  appliedFilters.value = filters.checkboxes;
  appliedDisplayPeriod.value = filters.displayPeriod;
  appliedStartDate.value = filters.startDate;
  appliedEndDate.value = filters.endDate;

  const params = getParamsFromFilter(filters);
  updateShintyokuSelectParams(params, 'replace', true);
  pageCursor.value = {};
  await loadJobList(params);

  // hide footer
  isBulkSelectionEnabled.value = false;
  // save current filter to session
  sessionStorage.setItem(MYPAGE_CONSTANTS.SESSION_KEY.PENDING_FILTERS, JSON.stringify(filters));
};

function updateShintyokuSelectParams(
  newParams: Partial<TrnShintyokuSelectRequest> = {},
  mode: 'replace' | 'merge' = 'merge',
  resetPage = false
): TrnShintyokuSelectRequest {
  let updatedParams: TrnShintyokuSelectRequest;

  if (mode === 'replace') {
    updatedParams = { ...newParams };
  } else {
    updatedParams = { ...shintyokuSelectParams.value };
    Object.entries(newParams).forEach(([key, value]) => {
      const paramKey = key as keyof TrnShintyokuSelectRequest;
      if (typeof value === 'string' || typeof value === 'number' || value === undefined) {
        updatedParams[paramKey] = value as any;
      }
    });
  }

  if (resetPage) {
    updatedParams.page = currentPage.value = 1;
  }
  // Update state
  shintyokuSelectParams.value = updatedParams;

  return updatedParams;
}

function getParamsFromFilter(filters: any){
  // build the search params
  const params : TrnShintyokuSelectRequest = {};
  // 表示期間
  if (appliedStartDate.value && appliedEndDate.value) {
    params.displayTime = {
      from: datefnsFormat(appliedStartDate.value, 'yyyy/MM/dd'),
      to: datefnsFormat(appliedEndDate.value, 'yyyy/MM/dd'),
    };
  }
  // Keep previous sort option
  params.orderBy = shintyokuSelectParams.value.orderBy;
  return params;
}

async function nextPage(){
  if (jobList.value.length < totalCount.value) {
    isLoadingMore.value = true;
    currentPage.value += 1;
    updateShintyokuSelectParams({page: currentPage.value});
    await loadJobList({page: currentPage.value}, false);
    isLoadingMore.value = false;
  }
}

async function loadJobList(params?: TrnShintyokuSelectRequest, isFullPageLoading = true){
  isLoading.value = isFullPageLoading;

  try{
    const requestParams: TrnShintyokuSelectRequest = {
      ...shintyokuSelectParams.value,
      ...(params || {}),
    };

    requestParams.pageCursor = pageCursor.value!;

    const jobSearchState = await getPendingListService(requestParams);
    const fetchedJobs = jobSearchState.shintyokuList;
    if (isArray(fetchedJobs)) {
      if (!requestParams.page || requestParams.page == 1) {
        jobList.value = fetchedJobs;
      } else {
        jobList.value = [...jobList.value, ...fetchedJobs];
      }
    }
    totalCount.value = jobSearchState.totalCount;

    const filterAvailable = jobSearchState.filterAvailable;
    minDate.value = filterAvailable.minDate!;
    maxDate.value = filterAvailable.maxDate!;
    if(filterAvailable && isInitFilter.value){
      isInitFilter.value = false;

      if(!appliedStartDate.value){
        appliedStartDate.value = new Date();
        appliedStartDate.value.setMonth(appliedStartDate.value.getMonth() - 3);
      }
      if(appliedStartDate.value < minDate.value){
        appliedStartDate.value = minDate.value;
      }
      if(!appliedEndDate.value){
        appliedEndDate.value = new Date();
      }
      if(minDate.value > appliedStartDate.value && minDate.value < appliedEndDate.value){
        appliedStartDate.value = minDate.value;
      }
      if(maxDate.value > appliedStartDate.value && maxDate.value < appliedEndDate.value){
        appliedEndDate.value = maxDate.value;
      }
      appliedDisplayPeriod.value = separatorDate(appliedStartDate.value) + ' - ' + separatorDate(appliedEndDate.value);
    }
    pageCursor.value = jobSearchState.pageCursor;
    hasMore.value = jobSearchState.hasMore;
    isJobListLoaded.value = true;
  } catch (error) {
    // TODO: Error handle
  }

  if (isFullPageLoading) {
    isLoading.value = false;
    // scroll to top
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

function turnAction(turnValue: boolean){
  isAction.value = turnValue;
}

const router = useRouter();
const isAction = ref(true);
const handleRefusalRemoveFavoritePublicOrders = async () => {
  if(!isAction.value)
  {
    return;
  }
  isAction.value = false;
  // Get only checked jobs from the job list
  const orders = jobList.value?.filter(v => v.checked) ?? [];

  // Get public jobs (isJobSearchPublic is true)
  const publicOrders = orders
    .filter(v => v.isJobSearchPublic)
    .map(v => Number(v.orderId));

  // Get private jobs (isJobSearchPublic is null or false)
  const privateOrders = orders
    .filter(v => v.isJobSearchPublic === null || v.isJobSearchPublic === false)
    .map(v => Number(v.orderId)).slice(0, 20);

  // If there are public jobs, remove them from favorites
  if (publicOrders.length > 0) {
    isLoadingMulti.value = true;
    await setLikeMypageBulkRemoveService({ orderIds: publicOrders });
    isLoadingMulti.value = false;
  }

  // Navigate to the refusal page with private job IDs as query parameters
  if (privateOrders.length > 0) {
      router.push({
      path: '/refusal/multiple',
      query: { orderIds: privateOrders }
    });
  }

  if (publicOrders.length > 0 && privateOrders.length === 0) {
    store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.UN_FAVORITE_DONE});
    jobList.value = jobList.value.filter(v => !v.checked);
    totalCount.value = jobList.value.length;
  }
  isAction.value = true;
};

const route = useRoute();
onActivated(async () => {
  isLoading.value = true;

  const orderChange = store.getters['favorites/favorites'];

  // Keep the page state when has back event
  if(route.meta.isBack && isJobListLoaded.value) {
    if(orderChange.orderId) {
      applyFavoriteChangeByOrderId(orderChange.orderId, orderChange.isLike);
      await nextTick();
    }
    isLoading.value = false;

    if(orderChange.orderId) {
      await nextTick();
      window.scrollTo({ top: savedScrollTop.value, behavior: 'smooth' });
      await store.dispatch('favorites/clearFavorite');
    }

    return;
  }
  await store.dispatch('favorites/clearFavorite');

  // Reset ref before set new value
  resetRefs();

  await handleOnActive();

  await loadJobList();
});

const handleOnActive = async() => {
  try {
    // get previours filters
    const filters = JSON.parse(sessionStorage.getItem(MYPAGE_CONSTANTS.SESSION_KEY.PENDING_FILTERS) || 'false');
    if (filters) {
      appliedFilters.value = filters.checkboxes;
      appliedDisplayPeriod.value = filters.displayPeriod;
      if (filters.startDate){
        appliedStartDate.value = new Date(filters.startDate);
      }
      if (filters.endDate){
        appliedEndDate.value = new Date(filters.endDate);
      }
      const params = getParamsFromFilter(filters);
      updateShintyokuSelectParams(params, 'replace', true);
    } else {
      isInitFilter.value = true;
      appliedStartDate.value = new Date();
      appliedStartDate.value.setMonth(appliedStartDate.value.getMonth() - 3);
      appliedEndDate.value = new Date();
      appliedDisplayPeriod.value = separatorDate(appliedStartDate.value) + ' - ' + separatorDate(appliedEndDate.value);
      shintyokuSelectParams.value.displayTime = {
        from: datefnsFormat(appliedStartDate.value, 'yyyy/MM/dd'),
        to: datefnsFormat(appliedEndDate.value, 'yyyy/MM/dd'),
      };
    }
  } catch (err){
    console.error(err);
    sessionStorage.removeItem(MYPAGE_CONSTANTS.SESSION_KEY.PENDING_FILTERS);
  }
}

function applyFavoriteChangeByOrderId(orderId: string, isLike: boolean) {
  const idx = getOrderIndexByOrderId(orderId);
  if (idx >= 0 && !isLike) {
    jobList.value.splice(idx, 1);
    totalCount.value--;
  }
}

function getOrderIndexByOrderId(orderId: string): number {
  return jobList.value.findIndex(j => String(j.orderId) === String(orderId));
}

const handleSaveScrollTop = () => {
  savedScrollTop.value = window.scrollY || window.pageYOffset || 0;
};

const resetRefs = () => {
  pageCursor.value = null;
  isBulkSelectionEnabled.value = false;
  shintyokuSelectParams.value = {};
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("main", null, [
          _createVNode(Loading, { "is-loading": isLoadingMulti.value }, null, 8, ["is-loading"]),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("form", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("p", _hoisted_10, [
                            _createTextVNode("全"),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(totalCount.value), 1),
                            _createTextVNode("件")
                          ]),
                          _hoisted_12
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              checked: "",
                              id: "switch",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isBulkSelectionEnabled).value = $event))
                            }, null, 512), [
                              [_vModelCheckbox, isBulkSelectionEnabled.value]
                            ]),
                            _hoisted_15
                          ]),
                          _withDirectives(_createElementVNode("label", _hoisted_16, [
                            _createElementVNode("input", {
                              class: "js-check-alljob",
                              type: "checkbox",
                              name: "",
                              onChange: handleCheckAllJob
                            }, null, 32),
                            _hoisted_17,
                            _hoisted_18,
                            _hoisted_19
                          ], 512), [
                            [_vShow, isBulkSelectionEnabled.value]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  (jobList.value.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
                    : _createCommentVNode("", true),
                  (jobList.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobList.value, (job) => {
                            return (_openBlock(), _createBlock(JobListItem, {
                              key: job.orderId,
                              job: job,
                              isBulkSelectionEnabled: isBulkSelectionEnabled.value,
                              screenName: job.isJobSearchPublic ? 'public' : 'jobSearch',
                              fromScreen: 'pending',
                              "is-public-order-detail": job.isLiked,
                              "onUpdate:checked": checked => updateJobChecked(job.progressId, Number(job.orderId), checked),
                              "onUpdate:favorite": favorite => updateJobFavorite(job, favorite),
                              "onWriteLog:pickUp": () => writeLog(Number(job.orderId), Number(job.clientId), job.pickupLink!),
                              onTurnAction: turnAction,
                              onSaveScrollTop: handleSaveScrollTop
                            }, null, 8, ["job", "isBulkSelectionEnabled", "screenName", "is-public-order-detail", "onUpdate:checked", "onUpdate:favorite", "onWriteLog:pickUp"]))
                          }), 128)),
                          _createElementVNode("div", _hoisted_25, [
                            (hasMore.value)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  disabled: isLoadingMore.value,
                                  class: "p-jobsearch-btn __blue __more",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (nextPage()))
                                }, [
                                  _createTextVNode(" 検索結果をもっと見る"),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["p-jobsearch-btn_ico", {'loading-spinner': isLoadingMore.value}])
                                  }, null, 2)
                                ], 8, _hoisted_26))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(JobSearchFilterModals, {
                  "is-display-modal-open": isDisplayModalOpen.value,
                  "recommendation-from-staff": appliedFilters.value?.recommendationFromStaff ?? false,
                  "recommendation-by-AI": appliedFilters.value?.recommendationByAI ?? false,
                  "new-arrivals": appliedFilters.value?.newArrivals ?? false,
                  "with-staff-comment": appliedFilters.value?.withStaffComment ?? false,
                  "unread-jobs-only": appliedFilters.value?.unreadJobsOnly ?? false,
                  "exclude-ended-applications": appliedFilters.value?.excludeEndedApplications ?? false,
                  "selected-start-date": appliedStartDate.value,
                  "selected-end-date": appliedEndDate.value,
                  "applied-display-period": appliedDisplayPeriod.value,
                  "from-screen": 'pending',
                  "min-date": minDate.value,
                  "max-date": maxDate.value,
                  "onUpdate:isDisplayModalOpen": _cache[2] || (_cache[2] = ($event: any) => (isDisplayModalOpen.value = $event)),
                  onApplyFilters: handleApplyFilters
                }, null, 8, ["is-display-modal-open", "recommendation-from-staff", "recommendation-by-AI", "new-arrivals", "with-staff-comment", "unread-jobs-only", "exclude-ended-applications", "selected-start-date", "selected-end-date", "applied-display-period", "min-date", "max-date"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(PendingFooter, {
          onAction: handleRefusalRemoveFavoritePublicOrders,
          isBulkSelectionEnabled: isBulkSelectionEnabled.value && _unref(isAnyCheckboxChecked),
          jobs: jobList.value,
          "is-loading": isLoading.value
        }, null, 8, ["isBulkSelectionEnabled", "jobs", "is-loading"])
      ])
    ]),
    _createVNode(Loading, {
      "is-loading": isLoading.value || !isAction.value
    }, null, 8, ["is-loading"])
  ], 64))
}
}

})